export const runSliders = () => {
	const sliders = window.sliders;

	const slidersControl = (id) => {
		const mobile = window.matchMedia('(min-width: 0px) and (max-width: 1199px)');
		const desktop = window.matchMedia('(min-width: 1200px)');

		if (mobile.matches && !window.sliders[id].init) {
			window.sliders[id].slider = new Swiper(`#${id}`, sliders[id].sliderSettings);
			window.sliders[id].init = true;
		} else if (desktop.matches && window.sliders[id].sliderSettings.destroyOnDesktop) {
			if (window.sliders[id].init) {
				window.sliders[id].slider.destroy();
				window.sliders[id].init = false;
			}
		} else if (!window.sliders[id].init) {
			window.sliders[id].slider = new Swiper(`#${id}`, sliders[id].sliderSettings);
			window.sliders[id].init = true;
		}
	}

	const debounce = (func, delay) => {
		let timeout;
		return function(...args) {
			const context = this;
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(context, args), delay);
		};
	};

	const debouncedSlidersControl = debounce((id) => {
		slidersControl(id);
	}, 100); // Adjust the delay as needed

	for (const sliderId in sliders) {
		sliders[sliderId] = {
			...sliders[sliderId],
			slides: document.querySelectorAll(`#${sliderId} .swiper-slide`).length,
			init: false
		}

		const { sliderData, slides } = sliders[sliderId];

		const sliderSettings = {
			watchSlidesProgress: true
		};

		let autoplayOptions = {};

		for (const key in sliderData) {
			switch (true) {
				case (key.includes('slidesPerView-') && sliderData[key] <= slides):
					sliderSettings.breakpoints = sliderSettings.breakpoints || {};
          console.log('sliderData.centeredSlides', sliderData.centeredSlides);
					sliderSettings.breakpoints[key.split('-')[1]] = { slidesPerView: sliderData[key], centeredSlides: sliderData.centeredSlides || false };
					break;
				case (key.includes('autoplay-')):
					autoplayOptions[key.split('-')[1]] = sliderData[key];
					break;
				default:
					sliderSettings[key] = sliderData[key];
			}
		};

		if (sliderSettings.autoplay) {
			sliderSettings.autoplay = autoplayOptions;
		}

		const navigation = {
			nextEl: `#${sliderId} .swiper-button-next`,
			prevEl: `#${sliderId} .swiper-button-prev`,
		}

		if (sliderSettings.navigation) {
			sliderSettings.navigation = navigation;
		}

		if (sliderSettings.pagination) {
			const pagination = {
				el: `#${sliderId} .swiper-pagination`,
				clickable: true,
			}

			if (sliderSettings.pagination?.type) {
				pagination.type = 'progressbar';
			}

      if (sliderSettings.pagination?.renderBullet) {
        pagination.renderBullet = sliderSettings.pagination.renderBullet;
      }


			sliderSettings.pagination = pagination;
		}

		sliders[sliderId].sliderSettings = sliderSettings;

		slidersControl(sliderId);

		window.addEventListener('resize', () => {
			debouncedSlidersControl(sliderId);
		});
	};
};